import { Chakra, Trustpilot } from "@airhelp/react-ui-components";
import { useTrustpilotInfo } from "contexts/DataContext";
import { useTranslations, useLocalizedData } from "contexts/LocalizationContext/hooks";

const { Flex } = Chakra;

export const TrustpilotSummary = ({ ...props }) => {
  const translations = useTranslations();
  const { getLocalizedNumber } = useLocalizedData();
  const {
    numberOfReviews: { total },
    score: { trustScore },
  } = useTrustpilotInfo();

  const translationVariables = {
    "%score%": `${getLocalizedNumber(trustScore)}/5`,
    "%number-of-reviews%": getLocalizedNumber(total),
  };
  const trustpilotText = translations("trustpilot", translationVariables);

  return (
    <Flex {...props} data-testid="trustpilot-banner">
      <Trustpilot text={trustpilotText} />
    </Flex>
  );
};
